/* import __COLOCATED_TEMPLATE__ from './company-profile-brands-form.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';

const CLASS_NAME = 'SH-c-company-profile-brands-form';

class BrandsForm extends Component {
  @service('state-managers/application') applicationStateManager;
  @service('commands/image-commands') imageCommandService;

  @tracked brandName = this.args.brand?.name ?? '';
  @tracked isThirdParty = this.args.brand?.isThirdParty ?? false;
  @tracked image = this.args.brand?.image ?? null;

  element = null;

  get className() {
    return CLASS_NAME;
  }

  get madeFormChange() {
    const { brand } = this.args;
    return brand.isThirdParty !== this.isThirdParty || brand.name !== this.brandName || brand.image !== this.image;
  }

  get formCanSubmit() {
    const { brand } = this.args;

    if (brand && !this.madeFormChange) {
      return false;
    }

    return this.brandName.length > 0 && this.image;
  }

  @task
  *uploadImage(e) {
    const [file] = e.target.files;
    e.target.value = '';

    try {
      this.image = yield this.imageCommandService.createDraftImage(file);
    } catch {
      this.applicationStateManager.addToast('Failed to upload image');
    }
  }

  @action
  handleUpdateField(name, value) {
    this[name] = value;
  }

  @action
  onInsert(element) {
    this.element = element;
  }

  @action
  onClick(e) {
    e.target.blur();
    this.element.click();
  }
}

export default BrandsForm;
